import { useState } from "react";
import { toast } from "sonner";
import { Label } from "@/components/ui/label";
import { PROJECT_TYPES } from "@/lib/constants";
import { errMsg } from "@/lib/api";
import { toggleType } from "@/components/wizard/StepType";
import { useEditor } from "./useEditorState";

// Project types (multi): used by the next AI generation; old single-type projects arrive as a one-item list.
export default function ProjectTypes() {
  const { project, setProject, api } = useEditor();
  const [busy, setBusy] = useState(false);
  const types = project.project_types?.length ? project.project_types : [project.project_type || "sito_vetrina"];
  const toggle = async (v) => {
    const next = toggleType(types, v);
    if (!next.length) return toast.error("Serve almeno una tipologia");
    setBusy(true);
    try { const { data } = await api.patch(`/projects/${project.id}`, { project_types: next }); setProject((p) => ({ ...p, project_type: data.project_type, project_types: data.project_types })); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div data-testid="editor-project-types">
      <Label className="text-[11px] uppercase tracking-wider text-slate-500">Tipologie</Label>
      <div className="mt-2 flex flex-wrap gap-1.5">
        {PROJECT_TYPES.map((t) => {
          const on = types.includes(t.value);
          return <button key={t.value} type="button" disabled={busy} aria-pressed={on} onClick={() => toggle(t.value)} data-testid={`editor-type-${t.value}`}
            className={`rounded-full border px-2.5 py-1 text-[11px] transition-colors ${on ? "border-sky-500 bg-sky-50 text-sky-800" : "border-slate-200 text-slate-600 hover:border-slate-300"}`}>{t.label}</button>;
        })}
      </div>
      <p className="mt-1 text-[11px] text-slate-500">Usate dalla prossima generazione AI; non cambiano il sito attuale.</p>
    </div>);
}
